@if (alertErroDados === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-2" src="/assets/img/error.png" width="61px" alt="Erro">
      <p class="titulo-alert">Erro referente aos dados!</p>
      <p class="subtitulo-alert">Os erros de dados serão ignorados, você pode prosseguir ou visualizar os erros para concertá-los.</p>
      <button class="botao-ignorar mt-3" routerLink="/visualizar-erros-importacao" id="verificarErros">Verificar erros</button>
      <button class="botao-ignorar-outline mt-3" (click)="ignorarErros()" id="ignorarErros">Ignorar erros e continuar</button>
    </div>
  </div>
}